import { useEvent } from '@/utils/useEventListener';
import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  connect() {
    if (this.element.dataset.formSubmit === 'auto') {
      this.submit();
    }

    useEvent(this, 'turbo:submit-end', this.#onSubmitEnd);
  }

  submit() {
    this.element.requestSubmit();
  }

  #onSubmitEnd(event) {
    if (event.detail.success) {
      this.dispatch('turbo-submit-success', { detail: event.detail });
    }
  }
}
